<template>
  <div class="content-width py-4" v-if="isAdmin">
    <div class="member-tab mb-4" v-if="isMobile">
      <ul class="nav nav-tabs" :class="{ 'nav-justified': isMobile }">
        <li class="nav-item">
          <router-link :to="{ name: '業務' }" v-slot="{ href, isActive }">
            <a class="nav-link style" :class="{ active: isActive }" :href="href"
              >業務</a
            >
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: '管理者' }" v-slot="{ href, isActive }">
            <a class="nav-link part" :class="{ active: isActive }" :href="href"
              >管理者</a
            >
          </router-link>
        </li>
      </ul>
    </div>
    <router-view
      :isMobile="isMobile"
      :search="search"
      :token="token"
    ></router-view>
  </div>
</template>
<style lang="scss" scoped>
.member-tab {
  background-color: #fff;
  .nav-tabs {
    border: none;
    .nav-link {
      color: #666;
      position: relative;
      &::after {
        content: "";
        width: 0;
        left: 50%;
        transform: translate(-50%, 50%);
        transition: all 0.3s ease-in-out;
      }
      &:hover,
      &:focus {
        border-color: transparent;
        &::after {
          content: "";
          width: 100%;
          height: 3px;
          background-color: #666;
          position: absolute;
          bottom: 0;
        }
      }
    }
    .nav-link.active,
    .nav-item.show .nav-link {
      border: none;
      color: #fff;
      background-color: $cms_main;
      &::after {
        content: "";
        width: 100%;
        height: 3px;
        background-color: $manage_sub;
        position: absolute;
        bottom: 0;
      }
    }
  }
}
.list-group-item.active {
  background-color: #d8e0f5;
  border: 1px solid $platform_main;
  color: $platform_main;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 1px;
}
.search-group {
  border: 1px solid #bdbdbd;
  max-width: 100%;
  margin-top: 20px;
  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>

<script>
export default {
  name: "Account",
  props: ["search", "isMobile", "token", "isAdmin"]
};
</script>
